import { Directive, HostListener, inject } from '@angular/core';
import { SetupTransactionService } from '../../tpi-services/shared-services/helper/setup-transaction.service';

@Directive({
    selector: '[tpiButtonClickDirective]'

})
export class ButtonClicktDirective {
    private transaction = inject(SetupTransactionService);

    @HostListener('click')
    onClick(): void {
        this.transaction.setupTransactionId();
    }
}